import { createContext } from 'react';

import { UseModalProviderContext } from './types';

export default createContext<UseModalProviderContext>({} as UseModalProviderContext);
